import React, {useEffect, useState} from 'react';
import './GloryHallPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import Pagination from '../../elements/Pagination/Pagination';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';
import {REGISTRY_SINGLETON} from '../../../scenes/Registry';
import {GloryHallUserItem} from './GloryHallUserItem';
import FloatingBackButton from '../../elements/FloatingBackButton/FloatingBackButton';

const PAGE_ID = 'GloryHallPage';
const PAGE_SIZE = 10;

function GloryHallPage({onBack, onUserClick}) {
  const [users, setUsers] = useState([]);
  // Сам игрок: сервер отдает его место и рейтинг отдельно (см. /users/rating)
  const [me, setMe] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  usePageAnalytics('GloryHallPage');

  useEffect(() => {
    const fetchRating = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE}/users/rating?limit=${PAGE_SIZE}&page=${page}`, {
          credentials: 'include',
        });
        if (!res.ok) throw new Error('Failed to fetch rating');
        const data = await res.json();
        setUsers(data.users || []);
        setMe(data.me || null);
        setTotalPages(data.totalPages || 1);
      } catch (e) {
        console.error('Glory hall error', e);
        setError('Не удалось загрузить зал славы');
      } finally {
        setLoading(false);
      }
    };

    fetchRating();
  }, [page]);

  const handlePageChange = (newPage) => {
    REGISTRY_SINGLETON.getSoundManager().playMenuButtonClick();
    setPage(newPage);
  };

  return (
    <>
      <FloatingBackButton onBack={onBack} pageId={PAGE_ID}/>

      <h1 className="glory-hall-page-title">Зал славы</h1>

      {loading && <p className="glory-hall-page-status">Загрузка...</p>}
      {error && <p className="glory-hall-page-status glory-hall-page-status_error">{error}</p>}

      {/* Шапка списка — всегда на месте, в стиле плашки игрока */}
      {!loading && !error && users.length > 0 && (
        <div className="glory-hall-page-header">
          <span className="glory-hall-page-header_place">Место</span>
          <span className="glory-hall-page-header_rating text-rating">Рейтинг</span>
        </div>
      )}

      {!loading && !error && (
        <>
          {users.length === 0 ? (
            <p className="glory-hall-page-status">Пока никого нет в зале славы</p>
          ) : (
            <>
              {/* Своя плашка над списком — только когда игрока нет на этой
                  странице: иначе он увидел бы себя дважды */}
              {me && !users.some((user) => user.id === me.id) && (
                <div className="glory-hall-page-own-item">
                  <GloryHallUserItem
                    user={me}
                    isCurrentUser
                    onClick={() => onUserClick(me.id, me.name)}
                    pageId={PAGE_ID}
                    buttonId={'own_user'}
                  />
                </div>
              )}

              <div className="glory-hall-page-list">
                {users.map((user, index) => (
                  <GloryHallUserItem
                    key={user.id}
                    user={user}
                    isCurrentUser={Boolean(me) && user.id === me.id}
                    onClick={() => onUserClick(user.id, user.name)}
                    pageId={PAGE_ID}
                    buttonId={`user_${index}`}
                  />
                ))}
              </div>
              <Pagination currentPage={page} totalPages={totalPages} onPageChange={handlePageChange}/>
            </>
          )}
        </>
      )}

      <div className="main-menu-buttons glory-hall-page-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default GloryHallPage;
